import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ITagResource } from "../types";

export type ITagDeleteMutationParameters = {
    tag: RelationalValue<ITagResource>;
};

export type ITagDeleteMutationResult = void;

export const tagDeleteMutation: IApiMutationFunction<ITagDeleteMutationParameters> = ({ tag }) => {
    return {
        method: "DELETE",
        url: `/tags/${mapRelationalValue(tag)}`,
    };
};

export const useTagDeleteMutation = createApiMutationHook<ITagDeleteMutationParameters, ITagDeleteMutationResult>(
    tagDeleteMutation,
);
